// @type flow
import React from 'react';

function withSelectable(DayComponent) {
  const SelectableDay = (props) => {
    const onClick = () => props.onClick(props.date);
    return (
      <DayComponent
        {...props}
        onClick={onClick}
        selected={props.selected}
      />
    );
  }

  return SelectableDay;
}

export default withSelectable;


// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/withSelectable.js